var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bleu",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "204.094px",
    height: "204.094px",
    viewBox: "0 0 204.094 204.094",
    enableBackground: "new 0 0 204.094 204.094",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0073A0",
    d: "M44.66,0L0,58.776v145.318h204.094V0H44.66z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.279,102.112v-0.065c0-6.447,4.86-11.727,11.824-11.727c4.276,0,6.835,1.425,8.941,3.499L35.87,97.48 c-1.749-1.588-3.531-2.559-5.799-2.559c-3.822,0-6.576,3.175-6.576,7.062v0.065c0,3.887,2.688,7.127,6.576,7.127 c2.592,0,4.179-1.037,5.96-2.656l3.175,3.207c-2.332,2.495-4.924,4.049-9.297,4.049C23.236,113.774,18.279,108.623,18.279,102.112z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.265,90.547h4.6l9.718,22.838h-5.216l-2.073-5.086h-9.589l-2.073,5.086h-5.086L52.265,90.547z  M57.513,103.893L54.5,96.54l-3.012,7.353H57.513z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.382,90.709h10.366c2.883,0,5.118,0.81,6.608,2.3c1.264,1.264,1.944,3.046,1.944,5.183v0.065 c0,3.66-1.976,5.96-4.859,7.029l5.539,8.098H85.15l-4.859-7.256h-3.92v7.256h-4.989V90.709z M81.425,101.723 c2.429,0,3.822-1.296,3.822-3.207v-0.065c0-2.138-1.49-3.239-3.919-3.239h-4.957v6.511H81.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.103,90.709h10.366c2.883,0,5.118,0.81,6.608,2.3c1.264,1.264,1.944,3.046,1.944,5.183v0.065 c0,3.66-1.976,5.96-4.859,7.029l5.539,8.098h-5.831l-4.859-7.256h-3.92v7.256h-4.989V90.709z M106.145,101.723 c2.429,0,3.822-1.296,3.822-3.207v-0.065c0-2.138-1.49-3.239-3.919-3.239h-4.957v6.511H106.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.825,90.709h17.104v4.438h-12.147v4.599h10.69v4.438h-10.69v4.762h12.31v4.438h-17.266V90.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.828,90.709h10.366c2.883,0,5.118,0.81,6.608,2.3c1.264,1.264,1.944,3.046,1.944,5.183v0.065 c0,3.66-1.976,5.96-4.859,7.029l5.539,8.098h-5.831l-4.859-7.256h-3.92v7.256h-4.989V90.709z M153.871,101.723 c2.429,0,3.822-1.296,3.822-3.207v-0.065c0-2.138-1.49-3.239-3.919-3.239h-4.957v6.511H153.871z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M168.549,90.709h17.104v4.438h-12.148v4.599h10.691v4.438h-10.691v4.762h12.31v4.438h-17.266V90.709z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98777551.svg";
export { ForwardRef as ReactComponent };